import {gql} from "@apollo/client";
import { client } from "graphql/client";
import { DeliveryTaskOrderType, DELIVERY_TASK_ORDER_FIELDS } from "../types/DeliveryTaskOrderType";

export const DELIVERY_FAILED_EVENT = gql`
  mutation DeliveryMutation($input: DeliveryFailedEventInput!) {
    result: handleDeliveryFailedEvent(input: $input) {
      ...DeliveryTaskOrderFields
    }
  }
  ${DELIVERY_TASK_ORDER_FIELDS}
`;

// 单张拍照照片的完整信息
export interface CameraExceptionPhotoInfo {
    s3Key: string;           // S3 存储路径
    latitude: number;        // 拍照时的纬度（如果没有则为0）
    longitude: number;       // 拍照时的经度（如果没有则为0）
}

// 相册照片组信息（共享一个位置）
export interface UploadExceptionPhotosInfo {
    latitude: number;        // 上传时的纬度（如果没有则为0）
    longitude: number;       // 上传时的经度（如果没有则为0）
}

export const HANDLE_DSP_FAILED = gql`
  mutation HandleDspDeliveryFailedEvent($input: DeliveryFailedEventInput!) {
    result: handleDspDeliveryFailedEvent(input: $input) {
      ...DeliveryTaskOrderFields
    }
  }
  ${DELIVERY_TASK_ORDER_FIELDS}
`;

export interface DeliveryFailedEventInput {
    trackingNumber: string;
    location: {
        latitude: number;
        longitude: number;
    };
    exceptionReasonCode:string;
    id: number;
    exceptionImageS3KeysJson?: string[]; // ✅ 保留原有字段（向后兼容）
    cameraPhotos?: CameraExceptionPhotoInfo[]; // ✅ 新增字段：拍照获得的照片（每张照片独立经纬度）
    uploadPhotos?: UploadExceptionPhotosInfo | null; // ✅ 新增字段：相册选择的照片（共享一个经纬度）
    /** 异常二级原因列表（枚举 code），如地址异常下选中的具体原因 */
    exceptionSubReasons?: string[] | null;
}

interface DeliveryFailedEventResponse {
    result: DeliveryTaskOrderType;
}

interface DeliveryFailedEventInputVariables {
    input: DeliveryFailedEventInput;
}

export const handleDeliveryFailedEvent = async (input: DeliveryFailedEventInput): Promise<DeliveryTaskOrderType | undefined>  => {
    const { data } = await client.mutate<DeliveryFailedEventResponse, DeliveryFailedEventInputVariables>({
        fetchPolicy: 'no-cache',
        mutation: DELIVERY_FAILED_EVENT,
        variables: { input },
    });
    return data?.result;
};

export const handleDspFailed = async (input: DeliveryFailedEventInput): Promise<DeliveryTaskOrderType | undefined>  => {
    const { data } = await client.mutate<DeliveryFailedEventResponse, DeliveryFailedEventInputVariables>({
        fetchPolicy: 'no-cache',
        mutation: HANDLE_DSP_FAILED,
        variables: { input },
    });
    return data?.result;
};